var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYtFooter = function SvgYtFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m21.101 14.04-9.888-5.493a1.096 1.096 0 0 0-1.09.015 1.094 1.094 0 0 0-.543.945v11.17c0 .395.212.754.55.951.344.198.761.19 1.098 0l9.888-5.676c.344-.198.556-.564.549-.96 0-.395-.22-.761-.564-.952m-9.324 4.74v-7.406l6.556 3.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.395 30h21.21A4.398 4.398 0 0 0 30 25.605V4.395A4.398 4.398 0 0 0 25.605 0H4.395A4.398 4.398 0 0 0 0 4.395v21.21A4.398 4.398 0 0 0 4.395 30M1.758 4.395a2.635 2.635 0 0 1 2.637-2.637h21.21a2.64 2.64 0 0 1 2.637 2.637v21.21a2.644 2.644 0 0 1-2.637 2.637H4.395a2.64 2.64 0 0 1-2.637-2.637z"
  })));
};
export default SvgYtFooter;